import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import Breadcrumb from '../../components/common/breadcrumb';
import DataTables from '../commonComponent/DataTable/DataTables';
import { FrontDesk_URL } from '../../constant';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import ToolTip from '../commonComponent/ToolTip';
import DeleteToolTip from '../UI/ToolTips/DeleteToolTip';

var glbRecords = [];
const Users = () => {
    let textSearch = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div>
                <span>{rowIndex + 1}</span>
            </div>
        </React.Fragment>
    }
    const actionFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div>
                <ToolTip title="Edit User" placement="top" onClick={() => editHandler(rowData.UserId)} linkId="Edit" faName="fa fa-pencil mr-2"></ToolTip>
                {
                    rowData.IsDefaultUser.toLowerCase() == "yes" ? null :
                        <>
                            &nbsp;&nbsp;
                            <DeleteToolTip title="Delete User" placement="top" id={`Delete${rowData.UserId}`} onClick={() => DeleteUser(rowData.UserId)} />
                        </>
                }
            </div>
        </React.Fragment>
    }
    const columns = [
        { dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
        { dataField: 'Name', text: 'Name', editable: false, headerStyle: (colum, colIndex) => { return { width: '25%' }; } },
        { dataField: 'Email', text: 'Email', editable: false, headerStyle: (colum, colIndex) => { return { width: '25%' }; } },
        { dataField: 'MobileNo', text: 'Mobile No', editable: false, headerStyle: (colum, colIndex) => { return { width: '10%' }; } },
        { dataField: 'IsDefaultUser', text: 'Default User', editable: false, headerStyle: (colum, colIndex) => { return { width: '10%' }; } },
        { dataField: 'IsActive', text: 'Is Active', editable: false, headerStyle: (colum, colIndex) => { return { width: '10%' }; } },
        { dataField: '', text: 'Action', formatter: actionFormatter, editable: false }
    ];
    const [tableData, setTableData] = useState([]);

    useEffect(() => { BindGrid(); }, []);
    const handleSearch = async () => {
        setTableData(
            glbRecords.filter((item) => item.Name.toLowerCase().indexOf(textSearch.current.value.toLowerCase()) !== -1 || item.Email.toLowerCase().indexOf(textSearch.current.value.toLowerCase()) !== -1));
    }
    const BindGrid = async () => {
        setIsLoading(true);
        let url = FrontDesk_URL + 'users/getcentrepartnerusers/' + localStorage.getItem('CentreSNo');
        await axios.get(url).then((response) => {
            const data = response.data;
            if (data.Success) {
                if (data.Data === null) { setTableData([]); }
                else {
                    glbRecords = data.Data;
                    setTableData(glbRecords);
                }
                setIsLoading(false);
            }
            else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); setIsLoading(false); }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } setIsLoading(false); });
    }
    const newHandler = async () => {
        history.push({ pathname: `${process.env.PUBLIC_URL}/users/details`, search: `` });
        localStorage.removeItem('uId');
    }
    const editHandler = async (CentreId) => {
        localStorage.setItem('uId', CentreId);
        history.push({ pathname: `${process.env.PUBLIC_URL}/users/details`, search: `` });
    }
    const DeleteUser = async (UserId) => {
        SweetAlert.fire({
            title: 'You are going to delete a user. Are you sure?',
            text: "Once deleted, you will not be able to recover!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then((result) => { if (result.value) { DeleteTotalUser(UserId); } else { SweetAlert.fire('Your data is safe!') } })

    }
    const DeleteTotalUser = async (UserId) => {
        setIsLoading(true);
        let url = FrontDesk_URL + 'users/deletetotaluser/' + UserId + '/' + localStorage.getItem("LoggedInUser")
        await axios.get(url).then((response) => {
            const data = response.data;
            if (data.Success) {
                SweetAlert.fire('Deleted!', 'Data has been deleted.', 'success');
                BindGrid();
                setIsLoading(false);
            }
            else {
                if (data.Data == "-2001") {
                    SweetAlert.fire('Validation', 'You cannot delete user because this user is a centre admin', 'error')
                }
                if (data.Data == "-2000") {
                    SweetAlert.fire({ title: "DB Error ", text: "Check db logs", icon: "error" });
                }
                else if (data.Data != "") {
                    SweetAlert.fire({ title: "Error is: ", text: data.Data, icon: "error" });
                }
                else {
                    SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" });
                }
                setIsLoading(false);
            }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } setIsLoading(false); });
    }
    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400")
            SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" })
        else if (ErrorCode == "401")
            SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" })
        else if (ErrorCode == "403")
            SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" })
        else if (ErrorCode == "404")
            SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" })
        else if (ErrorCode == "500")
            SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" })
        else if (ErrorCode == "503")
            SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" })
    }
    return (
        <React.Fragment>
            <Breadcrumb title="Users" parent="List" />
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row className="justify-content-center">
                                    <Col lg={4} md={6}>
                                        <Form.Group>
                                            <InputGroup className="mb-3">
                                                <Form.Control onChange={handleSearch} placeholder="Search by Name/Email..." ref={textSearch} />
                                                <InputGroup.Append>
                                                    <Button variant="secondary" onClick={handleSearch}><i className='fa fa-search'></i></Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2} md={6}>
                                        <Form.Group>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Append>
                                                    <Button variant='primary' type='submit' onClick={newHandler}>Add User</Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Header className='pb-0'>
                                <Card.Title>Users List</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {
                                    isLoading ?
                                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                        <>
                                            <DataTables keyField='id' tableData={tableData} columns={columns} />
                                        </>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}
export default Users;